<template>
    <div class="main-wrapper">
        <layout-header />

        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside">
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><vendor-sidebar></vendor-sidebar></div>
                        </div>
                    </div>

                    <div class="col-lg-9 col-md-12 mb-5">
                        <div class="border-bottom mb-3 d-flex justify-content-between align-items-center">
                            <h2 class="mb-0">Calendrier</h2>
                            <div class="btn-group btn-group-sm calendar-view-switch" role="group" aria-label="View mode selector">
                                <button type="button" class="btn"
                                    :class="viewMode === 'day' ? 'btn-primary' : 'btn-outline-secondary'"
                                    @click="setViewMode('day')">Jour</button>
                                <button type="button" class="btn"
                                    :class="viewMode === 'week' ? 'btn-primary' : 'btn-outline-secondary'"
                                    @click="setViewMode('week')">Semaine</button>
                                <button type="button" class="btn"
                                    :class="viewMode === 'month' ? 'btn-primary' : 'btn-outline-secondary'"
                                    @click="setViewMode('month')">Mois</button>
                            </div>
                        </div>

                        <div class="tab-content pt-0">
                            <div class="row mb-4">
                                <div class="col-lg-5">
                                    <div class="card-label mx-2 mb-1" v-if="viewMode === 'day'">
                                        <label>Date</label>
                                        <input type="text" class="form-control date" v-model="formattedDate" required />
                                    </div>
                                    <div class="card-label mx-2 mb-1" v-else>
                                        <label>Période</label>
                                        <div class="d-flex align-items-center justify-content-between border rounded px-2 py-1 period-navigator">
                                            <button type="button" class="btn btn-link p-0 text-dark" @click="shiftPeriod(-1)">
                                                <span class="material-symbols-outlined text-sm">arrow_back</span>
                                            </button>
                                            <span class="font-weight-semibold text-center px-2">{{ displayPeriodLabel }}</span>
                                            <button type="button" class="btn btn-link p-0 text-dark" @click="shiftPeriod(1)">
                                                <span class="material-symbols-outlined text-sm">arrow_forward</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-sm-6">
                                    <div class="card-label mx-2 mb-1" v-if="currentUser.role != 'owner'" >
                                        <label>Espace</label>
                                        <select v-model="selectedEstablishment" class="form-control custom-select" required>
                                            <option v-for="e in establishments" :value="e">{{ e.business_name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-sm-6">
                                    <div class="card-label mx-2 mb-1">
                                        <label>Terrain</label>
                                        <select v-model="selectedFacility" class="form-control custom-select" required>
                                            <option v-for="facility in facilities" :value="facility.id">{{ facility.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-5" v-if="viewMode === 'day'">
                                <div v-if="this.slots.length == 0" class="text-center">
                                    <span class="text-sm d-block mt-2">Aucun créneau.</span>
                                </div>
                                <div v-if="this.slots.length !== 0" class="row px-3">
                                    <div class="col-md-4 col-6 text-xs px-md-2 px-lg-3" v-for="(slot, index) in slots" :class="{'pl-2 pr-0': index % 2 !== 0, 'pl-0 pr-2': index % 2 === 0}">
                                        <div class="border rounded-xl my-2">
                                            <div>
                                                <div
                                                    class="d-flex justify-content-between align-items-center pl-3 pr-2 py-2 border-bottom bg-light rounded-xl">
                                                    <h5 class="m-0">
                                                        <i class="far fa-clock pr-1"></i>
                                                        {{ formatTime(slot.start_time) }} - {{ formatTime(slot.end_time) }}
                                                    </h5>
                                                    <div v-if="slot.status == 'available'">
                                                        <a class="btn text-sm d-inline-block px-1 pb-0 bg-light rounded-xl" data-toggle="dropdown" aria-expanded="false">
                                                            <i class="material-symbols-outlined text-lg">more_vert</i>
                                                        </a>
                                                        <div class="dropdown-menu dropdown-menu-right rounded-lg">
                                                            <a href="javascript:void(0)" class="dropdown-item" data-toggle="modal" data-target="#updateSlotModal"
                                                                @click="openUpdateSlotModal('booking', 'Réserver', slot)"
                                                                v-if="currentUser.role !== 'owner'">Réserver</a>
                                                            <a href="javascript:void(0)" class="dropdown-item" data-toggle="modal" data-target="#updateSlotModal"
                                                                @click="openUpdateSlotModal('blocking', 'Bloquer', slot)">Bloquer</a>
                                                            <a href="javascript:void(0)" class="dropdown-item" data-toggle="modal" data-target="#updateSlotModal"
                                                                @click="openUpdateSlotModal('price', 'Changer Prix', slot)">Changer prix</a>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <a href="javascript:void(0)" class="btn text-sm d-inline-block px-1 pb-0 rounded-xl" data-toggle="modal" data-target="#slotModal" @click="openModal(slot);this.getSlot()">
                                                            <i class="material-symbols-outlined text-lg">info</i>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-between align-items-center p-3">
                                                    <h5 class="flex-fill m-0 text-muted" v-if="slot.status !== 'blocked'">
                                                        <b v-if="!slot.sale_price">{{ slot.price }}<sup>DT</sup></b>
                                                        <b class="mr-1" v-if="slot.sale_price">{{ slot.sale_price }}<sup>DT</sup></b>
                                                        <s class="text-sm text-danger" v-if="slot.sale_price">{{ slot.price }}<sup>DT</sup></s>
                                                    </h5>
                                                    <h5 v-else></h5>
                                                    <div>
                                                        <span :class="slotStatuses[slot.status].class" class="badge badge-pill p-2">
                                                            {{ slotStatuses[slot.status].label }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-5" v-else>
                                <div v-if="daysInView.length === 0" class="text-center">
                                    <span class="text-sm d-block mt-2">Aucun créneau.</span>
                                </div>
                                <div v-else class="table-responsive text-xs p-0 py-2">
                                    <table class="table table-bordered table-center mb-0 calendar-grid-table">
                                        <thead class="bg-light">
                                            <tr>
                                                <th class="calendar-grid-day">Jour</th>
                                                <th v-for="hour in hourColumns" :key="`header-${hour}`">{{ hour }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="day in daysInView" :key="day.date">
                                                <td class="calendar-grid-day">{{ day.label }}</td>
                                                <td v-for="hour in hourColumns" :key="`${day.date}-${hour}`" :class="{ 'calendar-current-cell': isCurrentCell(day.date, hour) }">
                                                    <span v-if="getMatrixCell(day.date, hour)"
                                                        class="calendar-grid-cell"
                                                        role="button"
                                                        :class="slotStatuses[getMatrixCell(day.date, hour).status].class"
                                                        @click="openMatrixCellModal(day.date, hour)">
                                                        <a href="javascript:void(0)" class="text-reset font-weight-bold">
                                                            {{ getMatrixCell(day.date, hour).count }}
                                                        </a>
                                                    </span>
                                                    <span v-else class="text-muted">-</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-12 text-center text-muted text-sm position-relative mt-3 mb-1" v-if="viewMode === 'day'">
                                <hr class="position-absolute inset-0 my-0" style="top: 50%;"/>
                                <span class="my-2 px-3 bg-white position-relative">Séries des Crénaux</span>
                            </div>
                            

                            <div v-if="viewMode === 'day' && slotSeries.length == 0" class="text-center">
                                <span class="text-sm d-block mb-4 mt-2">Aucune série.</span>
                            </div>
                            <div v-else-if="viewMode === 'day'" class="mb-5">
                                <div class="table-responsive text-xs p-0 py-2">
                                    <table class="table table-hover table-center mb-0">
                                        <thead class="bg-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Du/À/Chaque</th>
                                                <th>Statut</th>
                                                <th>Nouveau Prix</th>
                                                <th>Désactivée le</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in paginatedData" :key="item.id" class="position-relative">
                                                <td>
                                                    <a v-if="!item.deleted_at" href="javascript:void(0)" class="btn btn-danger btn-sm py-1 px-2" @click="deleteSlotSerie(item.id)">
                                                        <span class="material-symbols-outlined text-sm">close</span>
                                                    </a>
                                                </td>
                                                <td style="min-width: 140px;">
                                                    <div>
                                                        Du <b>{{ formatLocaleDateTime(item.start_date).date }}</b>
                                                    </div>
                                                    <div>
                                                        À <b>{{ formatLocaleDateTime(item.end_date).date }}</b>
                                                    </div>
                                                    <div class="text-muted">
                                                        Chaque <b class="text-dark">{{ formatLocaleDateTime(item.start_date).date.split(' ')[0] }}</b>
                                                        de {{ item.start_time }} à {{ item.end_time }}
                                                    </div>
                                                    <div>
                                                        Chaque <b>{{ item.every_weeks }} semaine(s)</b>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span :class="slotStatuses[item.status].class" class="badge badge-pill p-2">
                                                        {{ slotStatuses[item.status].label }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="item.sale_price">{{ item.sale_price }}<sup>DT</sup></span>
                                                    <span v-else>-</span>
                                                </td>
                                                <td style="min-width: 120px;">
                                                    <span v-if="item.deleted_at">{{ formatLocaleDateTime(item.deleted_at).date }} à {{ formatLocaleDateTime(item.deleted_at).time }}</span>
                                                    <span v-else>-</span>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- PAGINATION -->
                                <nav class="mt-3">
                                    <ul class="pagination justify-content-center">
                                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                            <button class="page-link text-dark" @click="goToPage(currentPage - 1)">
                                                <span class="material-symbols-outlined text-sm">arrow_back</span>
                                            </button>
                                        </li>
                                        <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }">
                                            <button class="page-link" @click="goToPage(page)" :class="{ 'text-white': currentPage === page, 'text-muted': currentPage !== page }">
                                                {{ page }}
                                            </button>
                                        </li>
                                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                            <button class="page-link text-dark" @click="goToPage(currentPage + 1)">
                                                <span class="material-symbols-outlined text-sm">arrow_forward</span>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <layout-footer />
    </div>

    <!-- Modal -->
    <div class="modal fade" id="updateSlotModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ updateSlotModalTitle }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="d-flex justify-content-between align-items-top mb-2">
                        <div class="pt-2 w-100">
                            <div>{{ formattedDate || formatDateTime(currentSlot.start_time).date }}</div>
                            <div class="d-flex justify-content-start align-items-center my-1">
                                <input type="text" v-model="currentUpdateSlot.start_time" placeholder="HH:mm" :disabled="['price'].includes(updateSlotModalType)"
                                    style="height: auto;min-height: auto;padding: 0 5px;width: 64px;font-size: inherit;" class="form-control text-center">
                                <span class="mx-1">-</span>
                                <input type="text" v-model="currentUpdateSlot.end_time" placeholder="HH:mm" :disabled="['price'].includes(updateSlotModalType)"
                                    style="height: auto;min-height: auto;padding: 0 5px;width: 64px;font-size: inherit;" class="form-control text-center">
                            </div>
                            <!-- <div class="d-flex justify-content-start align-items-center mt-1">
                                {{ formatTime(currentSlot.start_time) }} - {{ formatTime(currentSlot.end_time) }}
                                <span class="btn btn-sm btn-info ml-1 py-0 px-1">
                                    <span class="material-symbols-outlined text-sm">edit</span>
                                </span>
                            </div> -->
                            <b>Prix Actuel: {{ currentSlot.price }}<sup>DT</sup></b>
                        </div>
                        <div class="pl-2 w-100">
                            <div class="form-group card-label" v-if="['price'].includes(updateSlotModalType)">
                                <label>Nouveau Prix</label>
                                <input type="number" min="0" class="form-control" v-model="currentSlot.sale_price"required />
                            </div>
                            <div v-if="updateSlotModalType == 'booking'">
                                <div class="card-label mb-1">
                                    <label>Réservation via:</label>
                                </div>
                                <div class="custom-control custom-radio ml-2" v-if="currentUser.role !== 'owner'">
                                    <input type="radio" id="slotChannel1" name="slotChannel" v-model="currentSlot.channel" value="website" class="custom-control-input">
                                    <label class="custom-control-label" for="slotChannel1">6v6</label>
                                </div>
                                <div class="custom-control custom-radio ml-2">
                                    <input type="radio" id="slotChannel2" name="slotChannel" v-model="currentSlot.channel" value="owner" class="custom-control-input">
                                    <label class="custom-control-label" for="slotChannel2">Propriétaire</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="['booking', 'blocking'].includes(updateSlotModalType)" class="p-3 bg-light rounded-xl mb-3">
                        <!-- <span class="h5 mb-2 d-block"><b>Infos Client:</b></span> -->
                        <div class="row my-1">
                            <div class="col-6 d-none">
                                <input type="text" class="form-control p-2" placeholder="Nom Complet" v-model="currentSlot.user_name" style="min-height: 38px;"/>
                            </div>
                            <div class="col-6 d-none">
                                <input type="text" class="form-control p-2" placeholder="N° Téléphone" v-model="currentSlot.user_phone" style="min-height: 38px;"/>
                            </div>
                            <div class="col-12">
                                <textarea class="form-control" rows="3" placeholder="Notes" v-model="currentSlot.notes"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-left align-items-center mb-2">
                        <label class="mb-0">Est récurrent?</label>
                        <div class="custom-control custom-switch ml-2">
                            <input type="checkbox" class="custom-control-input" v-model="currentUpdateSlot.is_recurrent" @change="loadDatepicker" id="recurrent" />
                            <label class="custom-control-label" for="recurrent"></label>
                        </div>
                    </div>
                    <div v-if="currentUpdateSlot.is_recurrent" class="mb-3">
                        <div class="d-flex justify-content-left align-items-center">
                            <span class="mr-1">Chaque</span>
                            <input type="number" min="1" value="1" class="form-control form-control-sm" v-model="currentUpdateSlot.every_weeks"
                                style="min-height: auto;width: 60px; padding: 0 5px;" />
                            <span class="ml-1">semaine(s)</span>
                        </div>
                        <div class="d-block">
                            <div class="d-flex align-items-center mt-2">
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="customRadioInline2" name="customRadioInline" v-model="currentUpdateSlot.condition" value="until" class="custom-control-input">
                                    <label class="custom-control-label" for="customRadioInline2"></label>
                                </div>
                                <div class="d-flex align-items-center">
                                    <span class="mr-1">Jusqu'à</span>
                                    <input type="text" class="form-control form-control-sm recurrent-slot-price-until" v-model="currentUpdateSlot.until" :disabled="currentUpdateSlot.condition !== 'until'"
                                        style="min-height: auto;width: 120px; padding: 0 5px; border: 1px solid lightgray;">
                                </div>
                            </div>
                            <div class="d-flex align-items-center mt-2">
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="customRadioInline1" name="customRadioInline" v-model="currentUpdateSlot.condition" value="occurences" class="custom-control-input">
                                    <label class="custom-control-label" for="customRadioInline1"></label>
                                </div>
                                <div class="d-flex align-items-center">
                                    <span class="mr-1">Ou pour</span>
                                    <input type="number" min="2" value="1" class="form-control form-control-sm mr-1"
                                        style="min-height: auto;width: 60px; padding: 0 5px;" v-model="currentUpdateSlot.occurences" :disabled="currentUpdateSlot.condition !== 'occurences'"/>
                                    <span class="">occurence(s)</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Retour</button>
                    <button v-if="updateSlotModalType == 'price'" type="button" class="btn btn-primary" @click="changePrice(currentUpdateSlot)">Changer</button>
                    <button v-if="updateSlotModalType == 'booking'" type="button" class="btn btn-danger" @click="bookSlot(currentUpdateSlot)">Réserver</button>
                    <button v-if="updateSlotModalType == 'blocking'" type="button" class="btn btn-danger" @click="blockSlot(currentUpdateSlot)">Bloquer</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="slotModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Détails Créneau</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="d-flex justify-content-between align-items-top mb-2">
                        <div class="text-sm">
                            {{ formattedDate || formatDateTime(currentSlot.start_time).date }}<br />
                            {{ formatTime(currentSlot.start_time) }} - {{ formatTime(currentSlot.end_time) }}<br />
                            Terrain {{ currentFacility?.name }}<br/>
                            <span v-if="currentSlot.status !== 'blocked'">{{ currentSlot.price }}<sup>DT</sup></span>
                        </div>
                        <div v-if="currentSlot.status" class="w-50 pl-2">
                            <div class="d-flex justify-content-between mb-2">
                                <span :class="slotStatuses[currentSlot.status].class" class="badge badge-pill p-2">
                                    {{ slotStatuses[currentSlot.status].label }}
                                </span>
                                <div v-if="currentSlot.status == 'booked'">
                                    <span v-if="currentSlot.channel == 'website'"> via 6v6</span>
                                    <span v-else-if="currentSlot.channel == 'owner'"> via Propriétaire</span>
                                </div>
                            </div>
                            <div class="py-3 px-2 rounded-xl bg-light w-100">
                                <span v-if="currentSlot.bookings">
                                    <span>{{ currentSlot.bookings[0]?.user_name }}</span>
                                </span>
                                <span class="px-1 d-block">{{ currentSlot.user_name }}</span>
                                <span class="px-1 d-block">{{ currentSlot.user_phone }}</span>
                                <span class="px-1 d-block">{{ currentSlot.notes }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Retour</button>
                    <button v-if="passedBooking() && currentSlot.channel != 'owner'" type="button" class="btn btn-danger" data-dismiss="modal">Non-présent</button>
                    <button v-if="!passedBooking()" @click="cancelBookedSlot(currentSlot.id)" type="button" class="btn btn-danger" data-dismiss="modal">Annuler</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="matrixCellModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Créneaux: {{ selectedMatrixCellLabel }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="selectedMatrixCellSlots.length === 0" class="text-center text-muted">
                        Aucun créneau.
                    </div>
                    <div v-else class="table-responsive">
                        <table class="table table-hover table-sm mb-0">
                            <thead class="bg-light">
                                <tr>
                                    <th>Heure</th>
                                    <th>Prix</th>
                                    <th>Statut</th>
                                    <th class="text-right">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="slot in selectedMatrixCellSlots" :key="slot.id">
                                    <td>{{ formatTime(slot.start_time) }} - {{ formatTime(slot.end_time) }}</td>
                                    <td>
                                        <span v-if="slot.status === 'blocked'">-</span>
                                        <span v-else>{{ slot.sale_price || slot.price }}<sup>DT</sup></span>
                                    </td>
                                    <td>
                                        <span :class="slotStatuses[slot.status].class" class="badge badge-pill p-2">
                                            {{ slotStatuses[slot.status].label }}
                                        </span>
                                    </td>
                                    <td class="text-right">
                                        <div v-if="slot.status == 'available'" class="d-inline-block text-left">
                                            <a class="btn text-sm d-inline-block px-1 pb-0 bg-light rounded-xl" data-toggle="dropdown" aria-expanded="false">
                                                <i class="material-symbols-outlined text-lg">more_vert</i>
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right rounded-lg">
                                                <a href="javascript:void(0)" class="dropdown-item"
                                                    @click="openUpdateFromMatrix('booking', 'Réserver', slot)"
                                                    v-if="currentUser.role !== 'owner'">Réserver</a>
                                                <a href="javascript:void(0)" class="dropdown-item"
                                                    @click="openUpdateFromMatrix('blocking', 'Bloquer', slot)">Bloquer</a>
                                                <a href="javascript:void(0)" class="dropdown-item"
                                                    @click="openUpdateFromMatrix('price', 'Changer Prix', slot)">Changer prix</a>
                                            </div>
                                        </div>
                                        <button v-else type="button" class="btn btn-sm btn-outline-primary" @click="openSlotFromMatrix(slot)">
                                            Détails
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Fermer</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.nav-tabs.nav-justified > li > a {
    width: max-content;
}
.ui-datepicker {
  z-index: 1150 !important; /* Bootstrap modal is usually 1050 */
  position: absolute !important;
}
.period-navigator {
    min-height: 38px;
}
.calendar-grid-table th,
.calendar-grid-table td {
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    padding: 0.35rem;
}
.calendar-grid-day {
    min-width: 140px;
    text-align: left !important;
    font-weight: 600;
}
.calendar-grid-cell {
    display: inline-block;
    min-width: 24px;
    border-radius: 999px;
    padding: 0.1rem 0.4rem;
    font-weight: 600;
}
.calendar-current-cell {
    background-color: #fff8cc;
}
</style>
<script>
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import VendorSidebar from "@/components/Vendors/Partials/Sidebar";

export default {
    components: {
        "vendor-sidebar": VendorSidebar,
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        displayPeriodLabel() {
            if (!this.selectedDate) return "";
            const pivot = moment(this.selectedDate);
            if (this.viewMode === 'week') {
                const start = pivot.clone().startOf('isoWeek');
                const end = pivot.clone().endOf('isoWeek');
                return `${start.format('DD/MM/YYYY')} - ${end.format('DD/MM/YYYY')}`;
            }
            if (this.viewMode === 'month') {
                return pivot.clone().startOf('month').format('MMMM YYYY');
            }
            return this.formattedDate || pivot.format('DD/MM/YYYY');
        },
        daysInView() {
            if (!this.selectedDate || this.viewMode === 'day') return [];
            const pivot = moment(this.selectedDate);
            const days = [];

            if (this.viewMode === 'week') {
                const start = pivot.clone().startOf('isoWeek');
                for (let i = 0; i < 7; i++) {
                    const current = start.clone().add(i, 'days');
                    days.push({
                        date: current.format('YYYY-MM-DD'),
                        label: current.format('ddd DD/MM'),
                    });
                }
                return days;
            }

            const start = pivot.clone().startOf('month');
            const end = pivot.clone().endOf('month');
            const cursor = start.clone();
            while (cursor.isSameOrBefore(end, 'day')) {
                days.push({
                    date: cursor.format('YYYY-MM-DD'),
                    label: cursor.format('ddd DD/MM'),
                });
                cursor.add(1, 'day');
            }
            return days;
        },
        hourColumns() {
            return Array.from({ length: 24 }, (_, index) => {
                const hour = (index + 6) % 24;
                return `${String(hour).padStart(2, '0')}:00`;
            });
        },
        multiDayMatrix() {
            const matrix = {};
            const statusPriority = {
                booked: 5,
                blocked: 4,
                pending: 3,
                available: 2,
                expired: 1,
            };

            this.multiDaySlots.forEach((slot) => {
                if (!slot.start_time) return;

                const date = moment(slot.start_time).format('YYYY-MM-DD');
                const hour = `${moment(slot.start_time).format('HH')}:00`;

                if (!matrix[date]) matrix[date] = {};
                if (!matrix[date][hour]) {
                    matrix[date][hour] = {
                        count: 0,
                        status: slot.status,
                        score: statusPriority[slot.status] || 0,
                    };
                }

                matrix[date][hour].count += 1;
                const nextScore = statusPriority[slot.status] || 0;
                if (nextScore > matrix[date][hour].score) {
                    matrix[date][hour].score = nextScore;
                    matrix[date][hour].status = slot.status;
                }
            });

            return matrix;
        },
        totalPages() {
            return Math.ceil(this.slotSeries.length / this.perPage);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.slotSeries.slice(start, start + this.perPage);
        },
    },
    data() {
        return {
            now: moment().format('YYYY-MM-DDTHH:mm:ss'),
            minCalendarDays: 0,
            formattedDate: null,
            selectedDate: null,
            viewMode: 'day',
            selectedFacility: null,
            selectedEstablishment: null,
            currentFacility: null,
            establishment: null,
            establishments: [],
            facilities: [],
            slots: [],
            slotStatuses: {
                'expired': {'label': 'expiré', 'class': 'bg-danger-light'},
                'blocked': {'label': 'bloqué', 'class': 'bg-danger-light'},
                'booked': {'label': 'réservé', 'class': 'bg-danger text-white font-weight-bolder'},
                'available': {'label': 'disponible', 'class': 'bg-success-light'},
                'pending': {'label': 'en cours', 'class': 'bg-warning-light'},
            },
            defaultUpdateSlot: {
                start_time: null,
                end_time: null,
                is_recurrent: false,
                every_weeks: 1,
                condition: 'until',
                occurences: 1,
                until: null
            },
            currentUpdateSlot: {},
            currentSlot: {},
            updateSlotModalTitle: '',
            updateSlotModalType: '',
            slotSeries: [],
            multiDaySlots: [],
            selectedMatrixCellSlots: [],
            selectedMatrixCellLabel: '',
            currentPage: 1,     // selected page
            perPage: 5,         // items per page
        }
    },
    mounted() {
        if (this.currentUser.role == 'owner') {
            this.getEstablishment()
            this.getFacilities()
        } else {
            this.getEstablishments()
        }
    },
    methods: {
        initMainDatepicker() {
            const vm = this;
            const minDays = Number.isFinite(this.minCalendarDays) ? this.minCalendarDays : 0;
            const $dateInput = $('.date');

            if (!$dateInput.length) return;

            if ($dateInput.hasClass('hasDatepicker')) {
                $dateInput.datepicker('destroy');
            }

            $dateInput.datepicker({
                dateFormat: 'DD, d MM yy',
                minDate: `-${minDays}D`,
                maxDate: '+2M',
                onSelect: (dateText) => {
                    const selectedDate = $.datepicker.parseDate('DD, d MM yy', dateText);
                    const formatted = $.datepicker.formatDate('yy-mm-dd', selectedDate);
                    vm.selectedDate = formatted;
                    vm.formattedDate = dateText;
                }
            });

            this.selectedDate = this.selectedDate || moment().format('YYYY-MM-DD');
            $dateInput.datepicker('setDate', $.datepicker.parseDate('yy-mm-dd', this.selectedDate));
            this.formattedDate = $dateInput.val();
        },
        setViewMode(mode) {
            this.viewMode = mode;
            this.selectedDate = this.selectedDate || moment().format('YYYY-MM-DD');

            if (mode === 'day') {
                this.$nextTick(() => {
                    this.initMainDatepicker();
                });
                this.getFacilitySlots();
                this.getFacilitySlotSeries();
                return;
            }

            this.getMultiDaySlots();
        },
        shiftPeriod(direction) {
            if (this.viewMode === 'day') return;

            const unit = this.viewMode === 'week' ? 'week' : 'month';
            const pivot = moment(this.selectedDate || moment()).add(direction, unit);
            this.selectedDate = pivot.format('YYYY-MM-DD');
            this.getMultiDaySlots();
        },
        getMatrixCell(date, hour) {
            return this.multiDayMatrix?.[date]?.[hour] || null;
        },
        isCurrentCell(date, hour) {
            const now = moment();
            const currentDate = now.format('YYYY-MM-DD');
            const currentHour = now.format('HH:00');
            return date === currentDate && hour === currentHour;
        },
        getSlotsForCell(date, hour) {
            const start = moment(`${date} ${hour}`, 'YYYY-MM-DD HH:mm');
            const end = start.clone().add(1, 'hour');
            return this.multiDaySlots
                .filter(slot => {
                    if (!slot.start_time) return false;
                    const slotStart = moment(slot.start_time);
                    return slotStart.isSameOrAfter(start) && slotStart.isBefore(end);
                })
                .sort((a, b) => moment(a.start_time).valueOf() - moment(b.start_time).valueOf());
        },
        openMatrixCellModal(date, hour) {
            this.selectedMatrixCellSlots = this.getSlotsForCell(date, hour);
            this.selectedMatrixCellLabel = `${moment(date).format('DD/MM/YYYY')} ${hour}`;
            $('#matrixCellModal').modal('show');
        },
        openSlotFromMatrix(slot) {
            this.currentSlot = { ...slot };
            $('#matrixCellModal').one('hidden.bs.modal', () => {
                $('#slotModal').modal('show');
                this.getSlot();
            });
            $('#matrixCellModal').modal('hide');
        },
        openUpdateFromMatrix(modalType, modalTitle, slot) {
            this.openUpdateSlotModal(modalType, modalTitle, slot);
            $('#matrixCellModal').one('hidden.bs.modal', () => {
                $('#updateSlotModal').modal('show');
            });
            $('#matrixCellModal').modal('hide');
        },
        refreshCalendarAfterMutation() {
            if (this.viewMode === 'day') {
                this.getFacilitySlots();
                this.getFacilitySlotSeries();
                return;
            }
            this.getMultiDaySlots();
        },
        showMutationSuccess(message) {
            this.$store.dispatch('modal/triggerModal', {
                icon: 'check_circle',
                icon_color: 'text-success',
                title: 'Succès',
                detail: message,
            });
        },
        showMutationError(message) {
            this.$store.dispatch('modal/triggerModal', {
                icon: 'error',
                icon_color: 'text-danger',
                title: 'Erreur',
                detail: message || 'Une erreur est survenue. Veuillez réessayer.',
            });
        },
        normalizeSlots(slots) {
            return slots.map(slot => {
                const is_occured = slot.start_time <= moment().format("YYYY-MM-DDTHH:mm:ss.000000")
                const is_expired = slot.expires_at && slot.expires_at <= moment().format("YYYY-MM-DDTHH:mm:ss.000000")
                slot.status = is_expired && !is_occured && !slot.available ? 'expired' : slot.status
                return {
                    ...slot
                }
            })
        },
        async getMultiDaySlots() {
            if (!this.selectedDate || !this.selectedFacility) {
                this.multiDaySlots = [];
                return;
            }

            const pivot = moment(this.selectedDate);
            const start = this.viewMode === 'week' ? pivot.clone().startOf('isoWeek') : pivot.clone().startOf('month');
            const end = this.viewMode === 'week' ? pivot.clone().endOf('isoWeek') : pivot.clone().endOf('month');

            const dates = [];
            const cursor = start.clone();
            while (cursor.isSameOrBefore(end, 'day')) {
                dates.push(cursor.format('YYYY-MM-DD'));
                cursor.add(1, 'day');
            }

            try {
                const requests = dates.map(date =>
                    api.get('/private/slots/' + date + '/facility/' + this.selectedFacility)
                        .then(response => response.data)
                        .catch(() => [])
                );
                const results = await Promise.all(requests);
                this.multiDaySlots = this.normalizeSlots(results.flat());
            } catch (error) {
                this.multiDaySlots = [];
            }
        },
        formatDateTime(datetimeString) {
            if (!datetimeString) return "";
            const formattedDate = datetimeString.split("T")[0];
            const datetime = {
                date: datetimeString.split("T")[0],
                time: datetimeString.split("T")[1].substring(0,5),
            };
            return datetime;
        },
        formatTime(datetimeString) {
            if (!datetimeString) return '';
            const date = new Date(datetimeString);
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        },
        getSlot() {
            api.get('/private/slots/'+this.currentSlot.id)
                .then(response => {
                    const result = response.data
                    this.currentSlot = result
                })
        },
        getEstablishments() {
            api.get('/private/establishment/list')
                .then(response => {
                    const result = response.data
                    this.establishments = result
                })
        },
        getEstablishment() {
            api.get('/private/establishment/')
                .then(response => {
                    const result = response.data
                    this.establishment = this.selectedEstablishment = result
                })
        },
        getFacilities() {
            api.get('/private/facilities')
                .then(response => {
                    const result = response.data
                    this.facilities = result
                    if (this.selectedEstablishment) {
                        this.facilities = this.facilities.filter(f => f.establishment_id == this.selectedEstablishment.id)
                    }
                    this.selectedFacility = this.facilities.length > 0 ? this.facilities[0].id : null
                })
        },
        getFacilitySlots() {
            if (!this.selectedDate || !this.selectedFacility)
                return
            api.get('/private/slots/'+this.selectedDate+'/facility/'+this.selectedFacility)
                .then(response => {
                    const result = response.data
                    this.slots = result.filter(slot => !slot.available || slot.start_time > moment().format("YYYY-MM-DDTHH:mm:ss.000000"))
                    this.slots = this.normalizeSlots(this.slots)

                })
        },
        getFacilitySlotSeries() {
            api.get('/private/slots/series/'+this.selectedFacility)
                .then(response => {
                    const result = response.data
                    this.slotSeries = result.filter(s => !s.deleted_at)
                })
        },
        changePrice(updateSlot) {
            this.currentSlot.status = 'available'
            this.currentSlot.available = true
            this.currentSlot.expires_at = null
            updateSlot.slot = this.currentSlot
            api.post('/private/slots/'+this.selectedFacility+'/sale_price', updateSlot)
                .then(response => {
                    this.refreshCalendarAfterMutation()
                    // Use the appropriate jQuery selector for your modals
                    $('.modal').modal('hide');
                    // Additionally, you might need to manually remove the backdrop if it persists
                    $('.modal-backdrop').remove();
                    this.showMutationSuccess('Prix modifié avec succès.')
                })
                .catch(error => {
                    this.showMutationError(error?.response?.data?.message)
                })
        },
        bookSlot(updateSlot) {
            this.currentSlot.status = 'booked'
            this.currentSlot.available = false
            this.expires_at = null
            this.currentSlot.sale_price = null
            updateSlot.slot = this.currentSlot
            api.post('/private/slots/'+this.selectedFacility+'/book', updateSlot)
                .then(response => {
                    this.refreshCalendarAfterMutation()
                    // Use the appropriate jQuery selector for your modals
                    $('.modal').modal('hide');
                    // Additionally, you might need to manually remove the backdrop if it persists
                    $('.modal-backdrop').remove();
                    this.showMutationSuccess('Créneau réservé avec succès.')
                })
                .catch(error => {
                    this.showMutationError(error?.response?.data?.message)
                })
        },
        blockSlot(updateSlot) {
            this.currentSlot.status = 'blocked'
            this.currentSlot.available = false
            this.expires_at = null
            this.currentSlot.sale_price = null
            updateSlot.slot = this.currentSlot
            api.post('/private/slots/'+this.selectedFacility+'/block', updateSlot)
                .then(response => {
                    this.refreshCalendarAfterMutation()
                    // Use the appropriate jQuery selector for your modals
                    $('.modal').modal('hide');
                    // Additionally, you might need to manually remove the backdrop if it persists
                    $('.modal-backdrop').remove();
                    this.showMutationSuccess('Créneau bloqué avec succès.')
                })
                .catch(error => {
                    this.showMutationError(error?.response?.data?.message)
                })
        },
        cancelBookedSlot(slot_id) {
            this.$store.dispatch('modal/triggerModal', {
                icon: 'warning',
                icon_color: 'text-warning',
                title: 'Confirmation',
                detail: "Êtes-vous sûr de vouloir annuler cette réservation ?",
                prompt: true,
                onResult: (confirmed) => {
                    if(confirmed) {
                        api.post('/private/slots/'+slot_id+'/cancel')
                            .then(response => {
                                this.getFacilitySlots()
                                this.getFacilitySlotSeries()
                                // Use the appropriate jQuery selector for your modals
                                $('.modal').modal('hide');
                                // Additionally, you might need to manually remove the backdrop if it persists
                                $('.modal-backdrop').remove();
                            })
                            }
                        }
            })
        },
        deleteSlotSerie(serie_id) {
            this.$store.dispatch('modal/triggerModal', {
                icon: 'warning',
                icon_color: 'text-warning',
                title: 'Confirmation',
                detail: 'Êtes-vous sûr de vouloir annuler cette série de créneaux ?',
                prompt: true,
                onResult: (confirmed) => {
                    if (confirmed) {
                        api.delete('/private/slots/series/' + serie_id)
                            .then(response => {
                                this.refreshCalendarAfterMutation()
                                this.showMutationSuccess('Série de créneaux supprimée avec succès.')
                            })
                            .catch(error => {
                                this.showMutationError(error?.response?.data?.message)
                            })
                    }
                }
            })
        },
        openUpdateSlotModal(modalType, modalTitle, slot) {
            this.updateSlotModalType = modalType
            this.updateSlotModalTitle = modalTitle
            this.currentUpdateSlot = { ...this.defaultUpdateSlot }
            this.currentSlot = { ...slot }
            this.currentUpdateSlot.start_time = this.formatTime(slot.start_time)
            this.currentUpdateSlot.end_time = this.formatTime(slot.end_time)
            if (this.currentUser.role == 'owner') {
                this.currentSlot.channel = 'owner'
            }
        },
        openModal(slot) {
            this.currentSlot = { ...slot }
            console.log(slot)
        },
        loadDatepicker() {
            if (this.currentUpdateSlot.is_recurrent) {
                const vm = this
                const defaultDate = new Date(this.currentSlot.start_time);
                const minDate = new Date(this.currentSlot.start_time);
                const delta = 7 * this.currentUpdateSlot.every_weeks
                minDate.setDate(minDate.getDate() + delta);
                $('.recurrent-slot-price-until').datepicker({
                    dateFormat: 'yy-mm-dd',
                    minDate: minDate,
                    defaultDate: defaultDate,
                    appendTo: 'body',
                    onSelect: (dateText) => {
                        vm.currentUpdateSlot.until = dateText;
                        // const selectedDate = $.datepicker.parseDate("d M yy", dateText);
                        // const formatted = $.datepicker.formatDate("yy-mm-dd", selectedDate);
                        // vm.formattedDate = dateText;
                    }
                });
            }
        },
        formatLocaleDateTime(datetimeString) {
            if (!datetimeString) return "";
            const date = new Date(datetimeString);
            const formattedDate = date.toLocaleString("fr-FR", { timeZone: "Africa/Tunis" }).split("T")[0];
            let displayDate = date.toLocaleDateString("fr-FR", { weekday: "short", year: "numeric", month: "short", day: "numeric" }).split("T")[0];
            displayDate = displayDate.split(" ") .map(word => word.charAt(0).toUpperCase() + word.slice(1)) .join(" ");
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            let date_obj = {
                date: displayDate,
                time: `${hours}:${minutes}`,
                datetime: formattedDate + ` ${hours}:${minutes}`,
            };
            return date_obj;
        },
        passedBooking() {
            return this.currentSlot.status == 'booked' && this.currentSlot.start_time <= moment().format('YYYY-MM-DDTHH:mm:ss')
        },
        goToPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },
    },
    watch: {
        'selectedDate': function(newValue) {
            if (this.viewMode === 'day') {
                this.getFacilitySlots()
                return
            }
            this.getMultiDaySlots()
        },
        'selectedEstablishment': function(newValue) {
            this.getFacilities()
            this.establishment = newValue
            const created_at = moment(this.establishment.created_at)
            const now = moment()
            this.minCalendarDays = now.diff(created_at, 'days')
            this.$nextTick(() => {
                this.initMainDatepicker();
            })
        },
        'selectedFacility': function(newValue) {
            this.selectedDate = !this.selectedDate ? moment().format('YYYY-MM-DD') : this.selectedDate
            if (this.viewMode === 'day') {
                this.$nextTick(() => {
                    this.initMainDatepicker();
                })
                this.getFacilitySlots()
                this.getFacilitySlotSeries()
            } else {
                this.getMultiDaySlots()
            }
            const facilities = this.facilities.filter(facility => facility.id == newValue)
            this.currentFacility = (facilities.length > 0) ? facilities[0] : null
        },
        'currentUpdateSlot.every_weeks': function(newValue) {
            const minDate = new Date(this.currentSlot.start_time);
            const delta = 7 * newValue
            minDate.setDate(minDate.getDate() + delta);
            $('.recurrent-slot-price-until').datepicker("option", "minDate", minDate);
            $('.recurrent-slot-price-until').datepicker("refresh");
        },
        'currentUpdateSlot.start_time': function(newValue) {
            const regex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
            if (regex.test(newValue)) {
                const start_time = this.formatDateTime(this.currentSlot.start_time)
                this.currentSlot.start_time = start_time.date+'T'+newValue+':00'
            }
        },
        'currentUpdateSlot.end_time': function(newValue, oldValue) {
            const regex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
            if (regex.test(newValue)) {
                let end_time = this.formatDateTime(this.currentSlot.end_time)
                const start_time = this.formatDateTime(this.currentSlot.start_time)
                if (end_time.date > start_time.date) {
                    if (end_time.time < newValue && newValue > start_time.time )
                        end_time = start_time
                }
                this.currentSlot.end_time = end_time.date+'T'+newValue+':00'
            }
        }
    }
};
</script>